import { render, staticRenderFns } from "./close-accounts.vue?vue&type=template&id=5e09c51a"
import script from "./close-accounts.vue?vue&type=script&lang=js"
export * from "./close-accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports